import React from "react";
import ReactWOW from "react-wow";

// https://www.iconfont.cn/collections/detail?spm=a313x.7781069.1998910419.d9df05512&cid=16990

class About extends React.Component {
  render() {
    return (
      <section
        id="about2"
        // className="white"
        style={{ backgroundImage: "Url(images/section-background-02.jpg)" }}
      >
        <div className="container">
          <div className="section-title">
            <h2 className="title-2">About the competition</h2>
          </div>
          <p>
            I’m the Best Coder! Challenge Campus Edition 2020 is a one-day data
            analytics competition, open to all undergraduate students.{" "}
          </p>
          <p>
            The competition consists of 2 rounds of data analysis problems
            designed by Shopee tech teams. Participants must analyse the
            dataset, draw insightful conclusions and solve the problems in a
            specified amount of time.{" "}
          </p>
          <p>
            Not only will participants get a chance to code to generate insights
            that solve real industry problems, this competition will also
            provide them with an opportunity to test their coding skills and
            understand the importance of data analytics skills required in
            Shopee.
          </p>
        </div>
      </section>
    );
  }
}

export default About;
